import { last } from "lodash";
import { appendUrlPrefix } from "./appendUrlPrefix";
import { fontThumbSrc } from "./images/fontThumbSrc";
import { zipFileImage } from "./images/zipFileImage";
import { audioFileImage } from "./images/audioFileImage";
import {
  isAudioType,
  isValidAssetTypeToPreview,
  isZipType,
} from "./utils.filetype";

export const getCAMThumbnail = (asset: WDAsset, pos = 3) => {
  const { thumbnailurls = [] } = asset;
  const isValidAssetType = isValidAssetTypeToPreview(asset);
  const { url, ...rest } = thumbnailurls[pos] ?? last(thumbnailurls);

  const getImageUrl = () => {
    if (isValidAssetType) {
      return url;
    }

    if (isZipType(asset.filetype)) {
      return zipFileImage;
    }

    if (isAudioType(asset.filetype)) {
      return audioFileImage;
    }

    return fontThumbSrc;
  };

  return {
    ...rest,
    url: appendUrlPrefix(getImageUrl()),
  };
};
